import React from 'react'

import { Provider } from 'react-redux'
import configureStore from './redux/create'
import { bootstrap } from './redux/modules/bootstrap/actions'
import { initialState as searchInitialState } from './redux/modules/search'

import { searchAppConfig } from './utils/propTypes'

import ManageDelegateForm from './containers/ManageDelegateForm'

export default function ManageDelegateApp ({ data: { results, ...pagination } = {}, ...appConfig }) {
  const initialState = {
    search: {
      ...searchInitialState,
      ...appConfig,
      results: results || [],
      pagination: pagination || {},
    },
  }
  console.log('search dashboard initial results are: ', initialState.search);
  const { store } = configureStore(initialState)
  store.dispatch(bootstrap())

  return (
    <Provider store={store}>
      <ManageDelegateForm />
    </Provider>
  )
}




// WEBPACK FOOTER //
// ./src/ManageDelegateApp.js